import { FC, ReactNode, useMemo } from 'react';

import { NON_BREAKING_SPACE, SortType } from 'utils/constants/common';

import Icon, { IconColor, IconKind, IconScale, IconView } from 'bloko/blocks/icon';

import 'components/LabelSort/LabelSort.less';

interface Sort {
    key: string;
    sort: SortType;
}

interface LabelSortProps {
    columnKey: string;
    children: ReactNode;
    sorts: Sort[];
    onClick: () => void;
}

const LabelSort: FC<LabelSortProps> = ({ columnKey, children, sorts, ...props }) => {
    const direction = useMemo(() => {
        const lastSort = sorts.length > 0 ? sorts[sorts.length - 1] : false;
        return lastSort && lastSort.key === columnKey ? lastSort.sort : '';
    }, [columnKey, sorts]);
    return (
        <span className="label-sort" {...props}>
            {children}
            {NON_BREAKING_SPACE}
            {direction === SortType.ASC && (
                <Icon view={IconView.Chevron} initial={IconColor.Gray50} kind={IconKind.Down} scale={IconScale.Small} />
            )}
            {direction === SortType.DESC && (
                <Icon view={IconView.Chevron} initial={IconColor.Gray50} kind={IconKind.Up} scale={IconScale.Small} />
            )}
        </span>
    );
};

export default LabelSort;
